import React, { Component } from 'react';
import RecurveUtility from '../../../functions/utility';
import { CategoryContext } from '../../../base_components/rootComponents/Category.jsx';
import Banner from '../../../utility_components/banner/Banner';
import { MenuItemCard } from '../../../ui/menuItemCard';
import { MenuItemCardContainer } from '../../../ui/menuItemCardContainer';
import { ItemCustomizationDialog } from '../../../ui/itemCustomization';

const marketingJson = {
    marketingMenuItems: [
        {
            posMenuId: 146,
            validUntil: '2026-02-05',
            marketingText: 'New',
            backgroundColor: 'red',
            fontColor: 'white',
            borderColor: 'red'
        },
        {
            posMenuId: 148,
            validUntil: '2026-02-05',
            marketingText: 'Trending 🔥',
            backgroundColor: '#008BFF',
            fontColor: 'white',
            borderColor: '#008BFF'
        }
    ],
    marketingDisplayItems: [
        {
            assetUrl: 'https://example.com',
            width: 1080,
            height: 1920,
            expiresAt: '2026-02-05T00:00:00Z',
            displayTitle: "Today's Feature",
            displayText: 'Try our Italian Beef — loaded, hot, and ready.',
            displayAtCheckout: true,
            displayAtHomeScreen: true,
            displayCtaButton: true,
            ctaUrl: 'https://example.com/',
            ctaButtonText: 'Order Now'
        }
    ],
    menuUpsellItems: [
        {
            description: 'Test Description',
            priority: 1,
            soldMenuItemId: 123,
            upsellMenuItemId: 124,
            upsellOnAllMenuItems: true
        }
    ]
};

export default class StreamlinedCategory extends Component {
    constructor(props) {
        super(props);
        this.utility = { ...RecurveUtility };
        this.state = {
            isItemDialogOpen: false,
            itemDialogUrl: null,
            itemDialogTitle: 'Customize item'
        };
        this.openItemDialog = this.openItemDialog.bind(this);
        this.handleItemDialogOpenChange = this.handleItemDialogOpenChange.bind(this);
    }

    openItemDialog(itemUrl, itemName) {
        this.setState({
            isItemDialogOpen: true,
            itemDialogUrl: itemUrl,
            itemDialogTitle: itemName || 'Customize item'
        });
    }

    handleItemDialogOpenChange(open) {
        this.setState({
            isItemDialogOpen: open,
            itemDialogUrl: open ? this.state.itemDialogUrl : null
        });
    }

    render() {
        return (
            <CategoryContext.Consumer>
                {(categoryContext) => {
                    const menuItemCards = [];
                    categoryContext.items.map((val, ind) => {
                        menuItemCards.push(
                            <MenuItemCard
                                menu_id={val.menu_id}
                                description={val.description}
                                label={val.name}
                                levelPrice={val.level_price}
                                matrixWeight={val.matrix_weight}
                                itemGroup={val.item_group}
                                imageUrl={val.imageURL}
                                onCallToAction={() => {
                                    this.openItemDialog(`${document.location}/items/${val.id}`, val.name);
                                }}
                                key={ind}
                                marketingJson={marketingJson}
                            />
                        );
                    });
                    return (
                        <div className='container'>
                            <Banner useLargeText imageLarge={categoryContext.imageUrl} headerText={categoryContext.name} description={categoryContext.description} callToActionText="Daily Deals" callToActionLink={`${window.relativeURI()}/menu`} />
                            <MenuItemCardContainer children={menuItemCards} />
                            <ItemCustomizationDialog
                                open={this.state.isItemDialogOpen}
                                onOpenChange={this.handleItemDialogOpenChange}
                                itemUrl={this.state.itemDialogUrl}
                                title={this.state.itemDialogTitle}
                            />
                        </div>
                    );
                }}
            </CategoryContext.Consumer>
        );
    }
}
